import * as TK from 'components/PDP/Details/components/PasControl/components/CollectionPrompt/translations/locale.constants';

export const collectionPromptCommonLocale = {
  [TK.MARKETPLACE_SUBTITLE]:
    "These gifts arrive in <emphasis>5-7 days</emphasis>, with an <highlight>Instant Digital Card Sent Today</highlight> so they know it's on the way.",
  [TK.SHOP_MARKETPLACE]: 'Shop Marketplace',
  [TK.SHOP_AVAILABLE_PRODUCTS]: 'Shop All',
};
